import InventoryContainer from './InventoryContainer';
import Inventory from './Inventory';

export default InventoryContainer;
export { Inventory };
